<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.from_date"
                                            placeholder="From date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.to_date"
                                            placeholder="To date"
                                        />
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Brand:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter the brand"
                                            v-model="params.brand"
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Item:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter the brand"
                                            v-model="params.item"
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Serial/IMEI:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter the sl/IMEI"
                                            v-model="params.sl"
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Collection Status:</span
                                        >
                                        <select
                                            v-model="params.collected"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">
                                                Not Collected
                                            </option>
                                            <option value="1">Collected</option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Buyback Type:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.type"
                                        >
                                            <option value="B">BUYBACK</option>
                                            <option value="U">UPGRADE</option>
                                            <option value="N">
                                                NOT APPLICABLE (OTHERS)
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div
                                    class="col-sm-4"
                                    v-if="
                                        $gate.isZonalManager() ||
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin() ||
                                        $gate.isCCManager() ||
                                        $gate.isCCAgent() ||
                                        $gate.isOnlineSalesManager() ||
                                        $gate.isOnlineSalesAssociate() ||
                                        $gate.isServiceAdmin()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <v-select
                                            v-model="params.branch"
                                            class="form-control"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Gatepass ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a valid ID"
                                            v-model="params.gatepass_id"
                                            type="number"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >BB_ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a valid ID"
                                            v-model="params.id"
                                            type="number"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Slab:</span
                                        >
                                        <v-select
                                            style="width: 100% !important"
                                            v-model="params.slab"
                                            :options="buyback_slabs"
                                            label="slab_name"
                                            :reduce="
                                                (buyback_slabs) =>
                                                    buyback_slabs.id
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created By:</span
                                        >
                                        <v-select
                                            v-model="params.created_by"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Updated By:</span
                                        >
                                        <v-select
                                            v-model="params.updated_by"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Results per Page:</span
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="params.results"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getBuybacks(
                                                    '/api/getBuybackReport'
                                                )
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>

                                <div
                                    class="col-sm-4"
                                    v-if="
                                        params.from_date != null &&
                                        params.to_date != null
                                    "
                                >
                                    <div
                                        class="form-group"
                                        v-if="$gate.isMISAdmin() && tl == true"
                                    >
                                        <button
                                            class="btn btn-success"
                                            style="width: 100% !important"
                                            @click="exportBuybackData"
                                        >
                                            Export
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-md-9">
                        DATASHEET V1.4 &nbsp;<button
                            class="btn btn-secondary"
                            @click="getBuybacks('/api/getBuybackReport')"
                        >
                            <i class="fa fa-refresh"></i> Refresh
                        </button>
                        <br />
                        <br />
                        <div class="col-md-12">
                            <div class="row" align="center">
                                <div class="col-lg-4 col-12">
                                    <!-- small box -->
                                    <div class="small-box bg-danger">
                                        <div class="inner">
                                            <h4>{{ pagination.total }}</h4>
                                            <p>Total Results</p>
                                        </div>
                                        <div class="icon">
                                            <i class="ion ion-person-add"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-12">
                                    <!-- small box -->
                                    <div class="small-box bg-warning">
                                        <div class="inner">
                                            <h4>
                                                {{ collected_sum | dotNumbers }}
                                            </h4>
                                            <p>Collected Goods Value</p>
                                        </div>
                                        <div class="icon">
                                            <i class="ion ion-pricetag"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-12">
                                    <!-- small box -->
                                    <div class="small-box bg-secondary">
                                        <div class="inner">
                                            <h4>
                                                {{ disposed_sum | dotNumbers }}
                                            </h4>
                                            <p>Realized from Disposal</p>
                                        </div>
                                        <div class="icon">
                                            <i class="ion ion-person"></i>
                                        </div>
                                    </div>
                                </div>

                                <!--                          <div class="col-lg-3 col-12">-->
                                <!--                              &lt;!&ndash; small box &ndash;&gt;-->
                                <!--                              <div class="small-box bg-danger">-->
                                <!--                                  <div class="inner">-->
                                <!--                                      <h4>{{opportunities | dotNumbers}}</h4>-->
                                <!--                                      <p>New/Opportunities</p>-->
                                <!--                                  </div>-->
                                <!--                                  <div class="icon">-->
                                <!--                                      <i class="ion ion-pie-graph"></i>-->
                                <!--                                  </div>-->
                                <!--                              </div>-->
                                <!--                          </div>-->

                                <!--                          <div class="col-lg-3 col-12">-->
                                <!--                              &lt;!&ndash; small box &ndash;&gt;-->
                                <!--                              <div class="small-box bg-orange">-->
                                <!--                                  <div class="inner">-->
                                <!--                                      <h4>{{converted | dotNumbers}}</h4>-->
                                <!--                                      <p>Converted</p>-->
                                <!--                                  </div>-->
                                <!--                                  <div class="icon">-->
                                <!--                                      <i class="ion ion-bag"></i>-->
                                <!--                                  </div>-->
                                <!--                              </div>-->
                                <!--                          </div>-->

                                <!--                          <div class="col-lg-3 col-12">-->
                                <!--                              &lt;!&ndash; small box &ndash;&gt;-->
                                <!--                              <div class="small-box bg-success">-->
                                <!--                                  <div class="inner">-->
                                <!--                                      <h4>{{lost | dotNumbers}}</h4>-->
                                <!--                                      <p>Lost</p>-->
                                <!--                                  </div>-->
                                <!--                                  <div class="icon">-->
                                <!--                                      <i class="ion ion-bin"></i>-->
                                <!--                                  </div>-->
                                <!--                              </div>-->
                                <!--                          </div>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <pagination
                            :pagination="pagination"
                            @prev="getBuybacks(pagination.prevPageUrl)"
                            @next="getBuybacks(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
                <br />
                <br />
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th scope="col">BBID</th>
                                    <th scope="col">Gatepass</th>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Buyback Type</th>
                                    <th scope="col">Item Name</th>
                                    <th scope="col">Slab</th>
                                    <th scope="col">IMEI/SL. No.</th>
                                    <th scope="col">Taken For</th>
                                    <th scope="col">Disposed For</th>
                                    <th scope="col">Collection Status</th>
                                    <th scope="col">Manage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="buyback in buybacks">
                                    <td>
                                        <p>{{ buyback.id }}</p>
                                        <p>
                                            {{ buyback.created_at | timeStamp }}
                                        </p>
                                    </td>
                                    <td>
                                        {{ buyback.gatepass_id
                                        }}<span
                                            v-if="buyback.order != null"
                                            class="badge badge-primary"
                                            @click="viewInvoice(buyback.order)"
                                            ><i class="fa fa-search"></i
                                        ></span>
                                    </td>
                                    <td>{{ buyback.branch_code }}</td>
                                    <td>{{ buyback.buyback_type }}</td>
                                    <td>
                                        <p>
                                            {{ buyback.brand }}
                                            {{ buyback.item_name }}
                                            <span
                                                class="badge badge-secondary"
                                                @click="
                                                    getBuybackImages(buyback.id)
                                                "
                                                ><i class="fa fa-search"></i
                                                >View Images</span
                                            >
                                        </p>
                                        <p>
                                            Added by:
                                            {{ buyback.creator.user_detail }}
                                        </p>
                                    </td>
                                    <td>
                                        {{ buyback.buyback_rule.slab_name }}
                                    </td>
                                    <td>{{ buyback.imei }}</td>
                                    <td>{{ buyback.taken_for }}</td>
                                    <td>{{ buyback.disposed_for }}</td>
                                    <td v-if="buyback.collected == true">
                                        Collected
                                    </td>
                                    <td v-if="buyback.collected == false">
                                        Not Collected
                                    </td>
                                    <td>
                                        <div class="col-sm-11">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <button
                                                        class="btn btn-secondary"
                                                        @click="
                                                            viewBuyback(
                                                                buyback.id
                                                            )
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-eye"
                                                        ></i>
                                                        View
                                                    </button>
                                                </div>
                                                <div class="col-md-6">
                                                    <button
                                                        v-if="
                                                            buyback.order !=
                                                            null
                                                        "
                                                        class="btn btn-primary"
                                                        @click="
                                                            disposedForPrompt(
                                                                buyback.id
                                                            )
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-edit"
                                                        ></i>
                                                        Dispose
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getBuybacks(pagination.prevPageUrl)"
                            @next="getBuybacks(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
            id="imagesmodal"
        >
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Buyback Item Images</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-6" v-for="i in buybackimages">
                                <img
                                    class="img-fluid"
                                    :src="i.url"
                                    alt="Buyback image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
            id="disposedmodal"
        >
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Dispose</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Disposed For</label>
                            <input
                                type="number"
                                placeholder="Enter the disposed amount"
                                class="form-control"
                                min="1"
                                v-model="disposed_for"
                            />
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary" @click="dispose">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { pagination: Pagination },

    created() {
        this.getSalesmen();
        this.getBranches();
        this.getBuybacks();
        this.getBuybackSlabs();
    },

    data() {
        return {
            buybacks: [],
            params: new Form({
                results: "",
                branch: "",
                slab: "",
                brand: "",
                sl: "",
                item: "",
                from_date: "",
                to_date: "",
                collected: "",
                type: "",
                gatepass_id: "",
                id: "",
                created_by: "",
                updated_by: "",
            }),
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
                branch: "",
            },
            buybackimages: [],
            buyback_slabs: [],
            branches: [],
            salesmen: [],
            curr_id: "",
            disposed_for: "",
            collected_sum: "0",
            disposed_sum: "0",
        };
    },

    methods: {
        getBuybacks(url = "/api/getBuybackReport") {
            axios.post(url, { params: this.params }).then((response) => {
                this.buybacks = response.data.data.data;
                this.collected_sum = response.data.total_value;
                this.disposed_sum = response.data.total_disposed;
                console.log(response.data.data.data);
                this.configPagination(response.data.data);
            });
        },

        getBuybackSlabs() {
            axios.post("/api/getBuybackSlabs").then((response) => {
                this.buyback_slabs = response.data;
            });
        },

        reset() {
            this.params.reset();
            this.getBuybacks("/api/getBuybackReport");
        },

        pollData() {
            this.interval = setInterval(() => {
                this.getBuybacks(
                    "/api/getBuybackReport" +
                        "?page=" +
                        this.pagination.currentPage
                );
            }, 30000);
        },
        getSalesmen() {
            axios.post("/api/getBranchCallAgents").then((response) => {
                this.salesmen = response.data;
            });
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getBuybackImages(id) {
            axios
                .post("/api/getBuybackImages", { buyback: id })
                .then((response) => {
                    this.buybackimages = response.data;
                    $("#imagesmodal").modal("show");
                });
        },

        disposedForPrompt(id) {
            this.curr_id = id;
            $("#disposedmodal").modal("show");
        },

        dispose() {
            axios
                .post("/api/buybackDisposed", {
                    id: this.curr_id,
                    disposed_for: this.disposed_for,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Item Disposed",
                    });
                    this.getBuybacks(
                        "/api/getBuybackReport" +
                            "?page=" +
                            this.pagination.currentPage
                    );
                    this.curr_id = "";
                    this.disposed_for = "";
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed! Please Check Input",
                    });
                });
        },

        viewBuyback(id) {
            window.open("/sales/buyback-report/details/" + id, "_blank");
        },

        viewInvoice(order) {
            window.open(
                "/invoice/" + order.id + "/" + order.gatepass_id,
                "_blank"
            );
        },
    },
};
</script>
